import { render } from "./StudentAptPassDataTable.vue?vue&type=template&id=eb045648"
import script from "./StudentAptPassDataTable.vue?vue&type=script&lang=js"
export * from "./StudentAptPassDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__